import { ulid } from 'ulid';
export function newId() {
    return ulid();
}
//# sourceMappingURL=id.js.map